import { createIcon } from '@chakra-ui/react';

export const LupaIcon = createIcon({
  displayName: 'LupaIcon',
  viewBox: '0 0 23 24',
  path: [
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      key="1"
      d="M8.65878 14.2549H7.90169L3.11961 19.2549L4.54753 20.7449L9.33919 15.7549V14.9649L9.59794 14.6849C10.6904 15.6649 12.1088 16.2549 13.6517 16.2549C17.0921 16.2549 19.8809 13.3449 19.8809 9.75488C19.8809 6.16488 17.0921 3.25488 13.6517 3.25488C10.2113 3.25488 7.42253 6.16488 7.42253 9.75488C7.42253 11.3649 7.98794 12.8449 8.92711 13.9849L8.65878 14.2549ZM17.9642 9.75488C17.9642 12.2449 16.0379 14.2549 13.6517 14.2549C11.2654 14.2549 9.33919 12.2449 9.33919 9.75488C9.33919 7.26488 11.2654 5.25488 13.6517 5.25488C16.0379 5.25488 17.9642 7.26488 17.9642 9.75488Z"
      fill="white"
    />
  ]
});
